<div class="container">
  <app-publisher-avatar class="ion-float-left" [publisher]="item.createdBy"></app-publisher-avatar>
  <p>
    <span>Posted by {{ item.createdBy?.displayName || 'Unknown' }}</span>
    @if (showPublisherLink) {
      <span> in </span>
    }
    @if (showPublisherLink) {
      <a class="channel" (click)="showChannel($event)">{{ item.channel.name }}</a>
    }
  </p>
</div>
